import { type ReactElement } from 'react';
import { isPermissionRefused } from '@citibox-panel/api-client';
import {
  CarrierExclusionListsPage,
  type ExclusionListCarrier,
} from '@citibox-panel/lockers-operations';
import { addExcludedUser, fetchExcludedUsers, removeExcludedUser } from '@/lib/apiClient';
import { useIsArrival } from '@/lib/arrival';
import { resolveMarket } from '@/lib/marketIndicator';
import { marketTimeZone } from '@/lib/marketTimeZone';
import { readRuntimeConfig } from '@/lib/runtimeConfig';

// The carriers that have an exclusion list, mirroring app-service's catalog: Amazon alone today. A
// second carrier is one more line here — and a panel release, exactly as it is one in backend.
const CARRIERS: readonly ExclusionListCarrier[] = [{ slug: 'amazon', name: 'Amazon' }];

// Composition root for the exclusion-lists screen: resolves the panel's zone, picks the reads and
// writes, and keeps the module free of any apps/shell dependency. The band is the Producto layout's.
export function CarrierExclusionListsRoute(): ReactElement {
  const arrived = useIsArrival();
  return (
    <CarrierExclusionListsPage
      carriers={CARRIERS}
      timeZone={marketTimeZone(resolveMarket(readRuntimeConfig()))}
      fetchExcludedUsers={fetchExcludedUsers}
      addExcludedUser={addExcludedUser}
      removeExcludedUser={removeExcludedUser}
      // A Rechazo por permiso already has the host's access screen, so the cards stay quiet on it.
      isHandledByHost={isPermissionRefused}
      focusHeadingOnArrival={arrived}
    />
  );
}
